export default "__VITE_ASSET__CT55K1Fr__"